import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { numberWithSpaces } from '../../../utils/math';
import { Hyperlink } from '../../../components/Hyperlink';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';
import { LawyerContext } from '../LawyerContext';

export const LawyerAllDecisionsButton: FC = () => {
  const {
    experience: { decisionCount },
    allDecisionsLink,
  } = useContext(LawyerContext);

  if (!decisionCount) return null;
  return (
    <Hyperlink
      className="button hollow"
      href={allDecisionsLink}
      source="read_all_lawyer_decisions_from_header"
    >
      <MaterialIcon name="search" />{' '}
      <FormattedMessage
        id="lawyer/page/LawyerAllDecisionsButton.tsx/1"
        values={{
          count: decisionCount,
          countFormatted: numberWithSpaces(decisionCount),
        }}
      />
    </Hyperlink>
  );
};
